import { isMonetaryField } from "../../shared/monetaryFields";

/**
 * The two rules that decide how a form field's value is painted in view mode.
 *
 * They live here, outside RenderFormElements, so the component and its tests
 * share one definition. They were previously inlined in the component and
 * copied into the test, and that copy is why a real bug survived: the test's
 * stand-in took `isPercent` as a prop, so it could not notice that one of the
 * component's two view branches never passed it.
 */

/**
 * True when a form field holds money and should render as UK Sterling.
 *
 * Driven by the backend form-collections metadata (`"format": "currency"`), with
 * the shared registry as a fallback for fields whose metadata has not been
 * tagged yet. `isPercent` always wins: `amount_flag` makes some fields a
 * percentage at runtime, and a percentage is never money.
 */
export const isCurrencyElement = (element: any, isPercent = false): boolean => {
  if (isPercent) return false;
  if (element?.format === "none") return false;
  return element?.format === "currency" || isMonetaryField(element?.field);
};

/**
 * True when this field is the commission `amount` AND the row's `amount_flag`
 * says that amount is a percentage rather than money.
 *
 * Scoped to the `amount` field deliberately: `amount_flag` describes `amount`
 * and nothing else on the form. Reading the flag alone would suffix a stray "%"
 * onto every other field rendered by the same branch — party name, note, case
 * type — whenever a percentage rule happened to be loaded.
 *
 * The flag arrives as a number from some endpoints and a string from others.
 */
export const isPercentAmountField = (element: any, values: any): boolean =>
  element?.field === "amount" &&
  (values?.amount_flag === 1 || values?.amount_flag === "1");
